import { Utils } from 'app/main/components';
// import { DetailsSectionFlowContent } from 'app/main/components/page-layouts';
import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import OrdersEvents from './OrdersEvents';

import OrdersDetailsSectionInfo from './details/sections/OrdersDetailsSectionInfo';
import OrdersDetailsSectionSecondaryInfo from './details/sections/OrdersDetailsSectionSecondaryInfo';
import DetailsSectionShipping from '../components/DetailsSectionShipping';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<OrdersDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<OrdersDetailsSectionSecondaryInfo {...props} />
			<InlineTitle text="DETAILS_SHIPPING_ADDRESS_SECTION" />
			<DetailsSectionShipping
				module="orders"
				editableAddress={Utils.getConnectionFromToken() !== 'PERCEPTIVE_CONTROL_BEB'}
				model={props.model}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			{props.model.ords_noteshtml && (
				<>
					<InlineTitle text="DETAILS_NOTES_SECTION" />
					<DescriptionSection
						name="ords_noteshtml"
						value={props.model.ords_noteshtml}
						isEdit={props.isEdit}
						sendChange={props.sendChange}
					/>
				</>
			)}
			<InlineTitle text="DETAILS_COMMENTS_SECTION" />
			<DescriptionSection
				name="ords_commentshtml"
				value={props.model.ords_commentshtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
		</>
	),
	events: OrdersEvents,
	showOpenFullDetails: true,
	onSuccess: ({ modifiedModel }) => {
		if (!modifiedModel._isCopy) {
			Utils.openLink({
				pathname: `/orders/details/${modifiedModel.ords_uid}/lines?openItemsAddDialog=true`
			});
		}
	}
};

export default dialogSettings;
